(function () {
  const initProductAccordion = () => {
    $(".about__accordion-toggle").click(function () {
      // LOBO CUSTOM C39: aria-expanded sincronizado (las preguntas frecuentes usan este mismo acordeón)
      $(this).attr("aria-expanded", !$(this).hasClass("active"));
      if (!$(this).hasClass("active")) {
        $(this).addClass("active");
        $(this)
          .siblings(".about__accordion-description")
          .eq($(this).index())
          .stop()
          .slideDown(300);
      } else {
        $(this).removeClass("active");
        $(this).siblings(".about__accordion-description").stop().slideUp(300);
      }
    });
  };

  document.addEventListener("shopify:section:load", function () {
    initProductAccordion();
  });

  initProductAccordion();
})();
